import { Button, Modal } from "react-bootstrap";
import { handleExportData } from "../Utils/helpers/commonhelper";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export const ExportDataPopup = ({ exportPop, setExportPop, heading, handleClose, handleFieldChange, exportData, module_name, fields, selectedFields }) => {
    const [customer, setCustomer] = useLocalStorageState("customer");
    const navigate = useNavigate();

    const headers = {
        Authorization: customer?.token?.authorization,
        Authentication: customer?.token?.authentication,
    };

    const extras = { customer, setCustomer, rf: headers.Authentication, navigate };

    const [loading, setLoading] = useState(false)

    const columnCount = 3;

    return (
        <Modal
            centered
            show={exportPop}
            onHide={() => setExportPop(false)}
            size="lg"
            contentClassName="border-0 shadow-sm"
        >
            <Modal.Header closeButton className="border-0 px-4 pt-4">
                <Modal.Title style={{ fontSize: '1.25rem', fontWeight: '600', color: '#334155' }}>
                    {heading}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="px-4 py-2">
                <div className="row g-4">
                    {[0, 1, 2].map((colIdx) => (
                        <div key={colIdx} className="col-md-4">
                            <div className="d-flex flex-column gap-2">
                                {fields
                                    .filter((_, index) => index % columnCount === colIdx)
                                    .map((col) => {
                                        const isChecked = selectedFields?.some(f => f.id === col.id);
                                        return (
                                            <label
                                                key={col.id}
                                                className="d-flex align-items-center m-0 p-1"
                                                style={{ cursor: 'pointer', transition: 'opacity 0.2s' }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input mt-0"
                                                    style={{
                                                        width: '16px',
                                                        height: '19px',
                                                        accentColor: '#000',
                                                        cursor: 'pointer'
                                                    }}
                                                    checked={isChecked}
                                                    onChange={() => handleFieldChange(col)}
                                                />
                                                <span
                                                    className="ms-2 text-secondary"
                                                    style={{
                                                        fontSize: '0.875rem',
                                                        color: isChecked ? '#000' : '#64748b',
                                                        fontWeight: isChecked ? '500' : '400'
                                                    }}
                                                >
                                                    {col.label}
                                                </span>
                                            </label>
                                        );
                                    })}
                            </div>
                        </div>
                    ))}
                </div>
            </Modal.Body>

            <Modal.Footer className="border-0 px-4 pb-4 pt-4">
                <button
                    onClick={handleClose}
                    disabled={loading}
                    className="btn btn-default-outline"
                    style={{
                        background: 'none',
                        border: 'none',
                        color: '#94a3b8',
                        fontSize: '0.875rem',
                        marginRight: '1rem'
                    }}
                >
                    Cancel
                </button>
                <Button
                    onClick={() => handleExportData(exportData, module_name, headers, extras, setLoading)}
                    className="btn btn-default"
                    style={{
                        border: 'none',
                        borderRadius: '6px',
                        padding: '8px 20px',
                        fontSize: '0.875rem',
                        fontWeight: '500'
                    }}
                >
                    {loading ? "Exporting..." : "Export Data"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};